import styled, { css } from "styled-components";

interface NavItemStyleProps {
  $active?: boolean;
}

export const NavItem = styled.li`
  width: 100%;
`;

export const NavLink = styled.div<NavItemStyleProps>`
  display: flex;
  width: 100%;
  height: 100px;
  color: ${(props) => props.theme.colors.black38};
  font-size: 1.4rem;
  font-family: "Pretendard";
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;

  svg {
    path {
      fill: ${(props) => props.theme.colors.black12};
    }
  }

  &:active {
    background: ${(props) => props.theme.colors.black10};
  }

  ${(props) =>
    props.$active === true &&
    css`
      color: ${props.theme.colors.primary100};

      svg {
        path {
          fill: ${props.theme.colors.primary100};
        }
      }
    `}

  // 모바일 환경(600px 이하) 설정
  @media (max-width: 600px) {
    height: 65px;
    font-size: 1rem;

    svg {
      width: 20px;
      height: 20px;
    }
  }
`;
